
import React from 'react';
import { useInstanceSettings } from '@/hooks/useInstanceSettings';
import DomainManagement from './domains/DomainManagement';
import AccountLimits from './accounts/AccountLimits';
import SettingsLoading from './common/SettingsLoading';

interface InstanceSettingsTabProps {
  instanceId: string;
}

const InstanceSettingsTab: React.FC<InstanceSettingsTabProps> = ({ instanceId }) => {
  const { 
    settings, 
    isLoading, 
    isSaving, 
    addDomain, 
    removeDomain, 
    setPrimaryDomain, 
    updateLimits, 
    toggleCustomDomain 
  } = useInstanceSettings(instanceId);

  if (isLoading) {
    return <SettingsLoading />;
  }

  return (
    <div className="space-y-6">
      <DomainManagement 
        settings={settings}
        isSaving={isSaving}
        addDomain={addDomain}
        removeDomain={removeDomain}
        setPrimaryDomain={setPrimaryDomain}
        toggleCustomDomain={toggleCustomDomain}
      />

      <AccountLimits 
        settings={settings}
        isSaving={isSaving}
        updateLimits={updateLimits}
      />
    </div>
  );
};

export default InstanceSettingsTab;
